import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import RunningTitleManager from "@/components/RunningTitleManager";
import { useAuth } from "@/context/AuthContext";

export default function Layout() {
  const { user, checked } = useAuth();

  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="h-screen flex bg-white text-slate-900 overflow-hidden">
      <RunningTitleManager />
      <Sidebar />
      <main className="flex-1 min-w-0 min-h-0 flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
